import { createSvg } from '../createSvg';
var Key = function (_a) {
    var _b = _a.strokeWidth, strokeWidth = _b === void 0 ? 1.5 : _b;
    return <>
        <g id={'contour'}>
            <path d='M19.7901 14.9301C17.7301 16.9801 14.7801 17.6101 12.1901 16.8001L7.48015
21.5001C7.14015 21.8501 6.47015 22.0601 5.99015 21.9901L3.81015 21.6901C3.09015 21.5901
2.42015 20.9101 2.31015 20.1901L2.01015 18.0101C1.94015 17.5301 2.17015 16.8601 2.50015 16.5201L7.20015
11.8201C6.40015 9.22007 7.02015 6.27007 9.08015 4.22007C12.0301 1.27007 16.8201 1.27007 19.7801
4.22007C22.7401 7.17007 22.7401 11.9801 19.7901 14.9301Z' strokeWidth={strokeWidth} strokeMiterlimit='10' strokeLinecap='round' strokeLinejoin='round'/>
            <path d='M6.89014 17.49L9.19014 19.79' strokeWidth={strokeWidth} strokeMiterlimit='10' strokeLinecap='round' strokeLinejoin='round'/>
            <path d='M14.5 11C15.3284 11 16 10.3284 16 9.5C16 8.67157 15.3284 8 14.5 8C13.6716 8 13 8.67157 13 9.5C13 10.3284 13.6716 11 14.5 11Z' strokeWidth={strokeWidth} strokeLinecap='round' strokeLinejoin='round'/>
        </g>
    </>;
};
export default createSvg(Key, 'key');
